export default "__VITE_ASSET__BkGyYFz7__"